import { render, staticRenderFns } from "./DailySeparator.vue?vue&type=template&id=3b5bcb47"
import script from "./DailySeparator.vue?vue&type=script&lang=js"
export * from "./DailySeparator.vue?vue&type=script&lang=js"
import style0 from "./DailySeparator.vue?vue&type=style&index=0&id=3b5bcb47&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports